import React, { useContext, useState } from "react";
import AccountsTree from "../components/ui/treesData/AccountsTree";
import AccountContext from "../utils/AccountsHelper";
import { AccountMngPop } from "../popups/AccountMngPop";
import { useTranslation } from "react-i18next";
import { CardHeadeWithActions, MwButton } from "../components/ui";
import { useTenant } from "../hooks";
import axios from "axios";

export const AccountsMgm = () => {
  const [t] = useTranslation("global");
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingChild, setLoadingchild] = useState(false);
  const [actionData, setActionData] = useState({
    mode: null,
    parentId: null,
    account: null,
  });
  const [code, setCode] = useState(null);
  const BaseUrl = process.env.REACT_APP_INV_API_SERVER_BASE_URL;
  const { tenantId, companySelected, branchSelected } = useTenant();
  const { editAccount, deleteAccount , accounts } = useContext(AccountContext);
  const GetCode = async () => {
    if (!tenantId || !companySelected?.value || !branchSelected?.value) {
      console.warn("Missing tenant/company/branch while generating account code", {
        tenantId,
        companyId: companySelected?.value,
        branchId: branchSelected?.value,
      });
      return null;
    }

    try {
      setLoading(true);
      const res = await axios.post(`${BaseUrl}/tree-account/genAccountNo/0`, {
        tenant_id: tenantId,
        company_id: companySelected?.value,
        branch_id: branchSelected?.value

      });
      
      return res?.data?.data;
      
    } catch (err) {
      console.error(
        "Failed to generate account code",
        err?.response?.data || err?.message || err
      );
      return null;
    } finally {
      setLoading(false);
    }
  };
  return (
    <section className="p-2 grid grid-cols-1 h-full items-start justify-start">
      <div className="flex flex-col gap-4">
        <CardHeadeWithActions
          title={t("menu.AccountsGuide")}
          icon={"/assets/icons/AccountingCertification.svg"}
        >
          <MwButton
            classNameCustom="w-max  text-white bg-[#261759] hover:bg-[#463977]"
            children={t("common.add")}
            onClick={async () => {
              setCode(null);
              setIsOpen(true);
              const newCode = await GetCode();
              setCode(newCode);
              setActionData({
                mode: "add",
                parentId: null,
                accountType: "primary",
                account: null,
              });
            }}
            type="newBtn"
          />
        </CardHeadeWithActions>
        <div className="min-w-[100%]  h-auto">
          <AccountsTree
            editAccount={editAccount}
            deleteAccount={deleteAccount}
            loading={loading}
            loadingChild={loadingChild}
            setLoadingchild={setLoadingchild}
            code={code}
            setIsOpen={setIsOpen}
            setCode={setCode}
            setActionData={setActionData}
          />
        </div>
      </div>
      <AccountMngPop
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        actionData={actionData}
        code={code}
        loading={loading}
        loadingChild={loadingChild}

        accounts={accounts}
      />
    </section>
  );
};
